var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "vs-table__controls-container",
      class: { "vs-table__controls-container--fixed": _vm.fixed }
    },
    [
      _c(
        "vs-layout",
        {
          staticClass: "vs-table__inputs-container",
          attrs: {
            "wrap-xs": "wrap-xs",
            "no-gutter": "no-gutter",
            "margin-bottom": "1"
          }
        },
        [
          !_vm.hideDate
            ? _c(
                "vs-layout",
                {
                  attrs: {
                    "no-gutter-left-lg": "no-gutter-left-lg",
                    lg: "6",
                    xl: "4",
                    "margin-top": "1"
                  }
                },
                [
                  _c("vs-date", {
                    ref: "datePicker",
                    attrs: {
                      clearable: "clearable",
                      "is-range-picker": "is-range-picker",
                      placeholder: "Dates",
                      "disable-after": _vm.moment.tz(_vm.timezone).endOf("day"),
                      timezone: _vm.timezone
                    },
                    on: {
                      "date-range-changed": function($event) {
                        return _vm.$emit("container-date-changed", $event)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          !_vm.hideSearch
            ? _c(
                "vs-layout",
                {
                  attrs: {
                    "no-gutter-right-lg": "no-gutter-right-lg",
                    lg: "6",
                    xl: "4",
                    "margin-top": "1"
                  }
                },
                [
                  _c("vs-input", {
                    attrs: {
                      clearable: "clearable",
                      "full-width": "full-width",
                      placeholder: _vm.searchPlaceholder,
                      value: _vm.searchText
                    },
                    on: {
                      input: function($event) {
                        return _vm.$emit("search", $event.target.value)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }